const LIMIT_TO_KEY = {
  max_orders_per_hour: 'errors.security.maxOrdersPerHour',
  max_orders_per_day: 'errors.security.maxOrdersPerDay',
  min_order_interval_seconds: 'errors.security.minOrderInterval',
  max_orders_per_ip_per_hour: 'errors.security.maxOrdersPerIpPerHour',
  max_orders_per_ip_per_day: 'errors.security.maxOrdersPerIpPerDay',
  max_users_per_ip_per_day: 'errors.security.maxUsersPerIpPerDay',
  max_order_amount: 'errors.security.maxOrderAmount',
  max_daily_amount_per_user: 'errors.security.maxDailyAmount',
  max_weekly_amount_per_user: 'errors.security.maxWeeklyAmount',
  max_items_per_order: 'errors.security.maxItemsPerOrder',
  max_quantity_per_item: 'errors.security.maxQuantityPerItem',
  max_total_quantity_per_order: 'errors.security.maxTotalQuantity',
  require_email_verification: 'errors.security.emailVerification',
  min_account_age_hours: 'errors.security.accountAge',
  new_account_max_order_amount: 'errors.security.newAccountAmount',
};

export function getSecurityErrorKey(error) {
  if (!error || error.code !== 'SECURITY_BLOCK') return null;

  if (error.limitExceeded && LIMIT_TO_KEY[error.limitExceeded]) {
    return LIMIT_TO_KEY[error.limitExceeded];
  }

  if (error.riskScore >= 80) return 'errors.security.riskBlock';

  return 'errors.security.accountBlocked';
}
